import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import MenuTitle from 'components/MenuTitle';
import {
  actSetAccountKybIncomplete,
  actGetAccountAllData,
  actShowDetailPage,
  actShowProfilePage,
  actShowBusinessPage,
  actShowPasswordPage,
  actShowNpwpPage,
} from 'actions/setting/account';
import withFeatureFlags from 'hocs/withFeatureFlags';
import styles from './style.css';
import AccountDetail from './AccountDetail';
import BusinessInfoDetail from './BusinessInfoDetail';
import IdDetail from './IdDetail';
import PasswordDetail from './PasswordDetail';
import AccountForm from './AccountForm';
import BusinessInfoForm from './BusinessInfoForm';
import PasswordForm from './PasswordForm';
import NPWPDetail from './NPWPDetail';
import NPWPUpload from './NPWPUpload';
import LanguageDetail from './LanguageDetail';

class Account extends React.Component {
  constructor(props) {
    super(props);
    this.showAccountDetail = this.showAccountDetail.bind(this);
    this.showUpdateProfile = this.showUpdateProfile.bind(this);
    this.showUpdateBusinessInfo = this.showUpdateBusinessInfo.bind(this);
    this.showUpdatePassword = this.showUpdatePassword.bind(this);
    this.closeReminder = this.closeReminder.bind(this);
    this.state = {
      showKybReminder: false,
    };
  }

  componentDidMount() {
    this.refreshAccountData();
  }

  refreshAccountData() {
    const {
      moka: { user },
    } = this.props.data;
    const isOwner = user && user.is_owner;
    const businessId = user && user.business.id;
    this.props.dispatch(actSetAccountKybIncomplete(null));
    this.props.dispatch(actGetAccountAllData(isOwner, businessId));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentPage !== this.props.currentPage) {
      switch (this.props.currentPage) {
        case 'SHOW_DETAIL':
          this.refreshAccountData();
          break;
        case 'RELOAD_DATA':
          this.showAccountDetail();
          break;
      }
    }
    if (prevProps.kybIncomplete !== this.props.kybIncomplete) {
      this.setState({
        showKybReminder:
          this.props.data.moka.user.is_owner && this.props.kybIncomplete,
      });
    }
  }

  showAccountDetail() {
    this.props.dispatch(actShowDetailPage());
  }

  showUpdateProfile() {
    this.props.dispatch(actShowProfilePage());
  }

  showUpdateBusinessInfo() {
    this.props.dispatch(actShowBusinessPage());
  }

  onClickUpdateNpwpInfo = () => {
    this.props.dispatch(actShowNpwpPage());
  };

  showUpdatePassword() {
    this.props.dispatch(actShowPasswordPage());
  }

  closeReminder() {
    this.setState({
      showKybReminder: false,
    });
  }

  render() {
    const { data, currentPage, kybNewContent, canChangeLanguage } = this.props;
    const { profile, businessKyb, kyb, moka } = data;
    const { user } = moka;
    const isOwner = user && user.is_owner;
    const kybReminder = this.state.showKybReminder ? (
      <div className={`row ${styles.reminder}`}>
        <div className="col-md-8">
          <div className={`${styles['icon-info']} pull-left`} />
          <div>
            <i className={styles['reminder-title']}>Activate Mobile Payments</i>
            <br />
            <i className={styles['reminder-description']}>
              Complete your details so that you can start using mobile payments.
            </i>
          </div>
        </div>
        <div className="col-md-4">
          <Link to="/kyb">
            <a className={`btn btn-primary ${styles['reminder-activate']}`}>
              Activate
            </a>
          </Link>
          <span
            className={`close-notification ${styles['reminder-close']}`}
            onClick={this.closeReminder}
          >
            {' '}
            &times;{' '}
          </span>
        </div>
      </div>
    ) : (
      <div />
    );
    let activePage;
    const firstName =
      profile.first_name === undefined ? '' : profile.first_name;
    const lastName = profile.last_name === undefined ? '' : profile.last_name;
    const accountData = {
      fullName: firstName + (lastName === '' ? lastName : ` ${lastName}`),
      email: profile.email,
      phone: profile.phone,
      isPhoneVerified: profile.is_phone_number_verified,
      isEmailVerified: profile.is_confirmed,
    };
    switch (currentPage) {
      case 'UPDATE_PROFILE':
        activePage = [
          <div className="col-md-6 col-lg-4 col-12" key={0}>
            <AccountForm
              accountData={accountData}
              onClickBack={this.showAccountDetail}
            />
          </div>,
        ];
        break;
      case 'UPDATE_BUSINESS_INFO':
        activePage = [
          <div className="col-md-6 col-lg-4 col-12" key={1}>
            <BusinessInfoForm
              moka={moka}
              businessKyb={businessKyb}
              onClickBack={this.showAccountDetail}
            />
          </div>,
        ];
        break;
      case 'UPDATE_NPWP_INFO':
        activePage = [
          <div className="col-md-6 col-lg-5 col-12" key={2}>
            <NPWPUpload
              identity={kyb}
              onClickBack={this.showAccountDetail}
              business={businessKyb}
            />
          </div>,
        ];
        break;
      case 'UPDATE_PASSWORD':
        activePage = [
          <div className="col-md-6 col-lg-4 col-sm-12" key={3}>
            <PasswordForm
              accountData={accountData}
              onClickBack={this.showAccountDetail}
            />
          </div>,
        ];
        break;
      default:
        activePage = [
          <div className="col-md-6 col-lg-5 col-12" key={4}>
            <AccountDetail
              accountData={accountData}
              onClickUpdateProfile={this.showUpdateProfile}
            />
            <BusinessInfoDetail
              isOwner={isOwner}
              businessKyb={businessKyb}
              onClickUpdateBusinessInfo={this.showUpdateBusinessInfo}
            />
            {isOwner && <IdDetail kyb={kyb} businessKyb={businessKyb} />}
            {isOwner && (
              <NPWPDetail
                identity={kyb}
                isOwner={isOwner}
                onClickUpdateNpwpInfo={this.onClickUpdateNpwpInfo}
                business={businessKyb}
              />
            )}
            <PasswordDetail onClickUpdatePassword={this.showUpdatePassword} />
          </div>,

          canChangeLanguage && (
            <div className="col-md-6 col-lg-5 col-12" key={5}>
              <LanguageDetail />
            </div>
          ),
        ];
        break;
    }
    return (
      <div id="account-setting">
        {!kybNewContent && kybReminder}
        <MenuTitle menuTitle="Account" column="12" />
        <div className="row">{activePage}</div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: {
      moka: state.moka,
      profile: state.setting.account.profile,
      businessKyb: state.setting.account.business_kyb,
      kyb: state.setting.account.kyb,
    },
    currentPage: state.setting.account.current_page,
    kybIncomplete: state.setting.account.kyb_incomplete,
  };
}

const connected = connect(mapStateToProps)(Account);

const mapFlagsToProps = flags => ({
  kybNewContent: flags.kybNewContent,
  // Turning this off for the moment. The account-level setting
  // requires API support
  canChangeLanguage: false && flags.enableLanguageSettings,
});

export default withFeatureFlags(mapFlagsToProps)(connected);
